/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'glyph/16/expand': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M16 7.1V0H8.9l2.9 2.9-8.9 8.9L0 8.9V16h7.1l-2.9-2.9 8.9-8.9z" _fill="#272c33"/>'
  }
})
